import React from 'react'

import { Disclosure } from '@cred/react-disclosures-sdk'

import styles from './styles.module.scss'

const PaymentsModal = () => {
  return (
    <div className={styles.contentWrap}>
      <div className={`${styles.disclosureContent} bodySmall neutral500`}>
        <Disclosure required={false} slug="partners-widgets.mortgage-combined.payment.disclosure" />
      </div>
    </div>
  )
}

export default PaymentsModal
